import React from 'react';
import { ILayoutProps } from 'react-dropzone-uploader';

const Layout = (props: ILayoutProps): React.ReactNode => (
  <div {...props.dropzoneProps}>
    {props.files.length < props.extra.maxFiles && props.input}
  </div>
);


export default Layout;
